


















































import { Vue, Component, Watch } from 'vue-property-decorator';
import LessonListSearchPanel, { SearchCondition } from './LessonListSearchPanel.vue';
import StudentLessonRequestDialog from './StudentLessonRequestDialog.vue';
import CommonCalendar, { CalendarEvent, DateClickEvent, EventColor } from '../../components/organisms/CommonCalendar.vue';

// import ListCell from './ListCell.vue';
import { TeacherService } from '../../biz/remote/TeacherService';
import { Session } from '../../utils/Session';
import { MessageDialog } from '../../utils/MessageDialog';
import { TimeGridView } from '@fullcalendar/timegrid';
import { dayjs, DT_FORMAT_INPUT } from '../../../src_server/common/momentExtends';
import { DaLessonScheduleDTO } from '../../../src_server/entity/dto/DaLessonScheduleDTO';
import { routeHelper } from '../../utils/routeHelper';
import { StudentService } from '../../biz/remote/StudentService';

@Component({
  components: {
    StudentLessonRequestDialog,
    LessonListSearchPanel,
    CommonCalendar,
  },
})
export default class DaStudentLessonReservationCalendarPage extends Vue {
  private lessons: DaLessonScheduleDTO[] = [];
  private condition?: SearchCondition = new SearchCondition();
  private calendarEvents: CalendarEvent[] = [];

  // 検索設定を覚えておく機能
  mounted() {
    let condition = Session.get<SearchCondition>('TEACHER_SEARCH_CONDITION');
    if (condition) {
      this.condition = condition;
    }
  }

  @Watch('condition', { deep: true })
  @Watch('lessons')
  lessonToCalendar() {
    const school_year = this.condition?.school_year;
    console.log('school_year', school_year);
    this.calendarEvents = this.lessons
      .filter((l) => {
        const conditionYears = school_year?.split(',') || [];
        if (conditionYears?.length < 1 || !conditionYears[0]) return true;
        const dataYears = l.teacher?.target_school_year?.split(',');
        console.log(
          ' dataYears,conditionYears',
          dataYears,
          conditionYears,
          dataYears?.some((p) => conditionYears?.includes(p))
        );
        return dataYears?.some((p) => conditionYears?.includes(p));
      })
      .map((l) => {
        return {
          title: `${l.teacher?.nickname} ${l.selectedCourse ? '\n⭐️あなたの選択コース⭐️' : ''}`,
          start: dayjs(l.shiftTable?.start_time).format(DT_FORMAT_INPUT),
          end: dayjs(l.shiftTable?.end_time).format(DT_FORMAT_INPUT),
          backgroundColor: EventColor.SCHEDULE,
          type: 'teacher_enable',
          id: l.shiftTable?.shift_table_id,
          teacher_user_id: l.teacher?.user_id,
        } as CalendarEvent;
      });
    console.log(this.calendarEvents);
  }

  /**
   * オリジナルのデータを読み出す
   */
  async loadData(start: Date, end: Date) {
    console.log('loadData');
    const biz = new TeacherService();
    const response = await biz.getDaLessons(dayjs(start).format(DT_FORMAT_INPUT), dayjs(end).format(DT_FORMAT_INPUT), Session.getSessionBuildingId());
    this.lessons = response.data;

    const sbiz = new StudentService();
    const responseStu = await sbiz.getDaStudentSelectedCourse(Session.getSessionUserId());
    const stuSelectedCourse = responseStu.data;

    // 選択コースと一覧をマージ
    this.lessons = this.lessons.map((i) => {
      i.selectedCourse = !!stuSelectedCourse.find((value) => value.teacher_user_id === i.teacher?.user_id);
      return i;
    });
  }

  /**
   * 検索条件が変わったときのハンドラ
   */
  conditionChange(value: any) {
    // console.log('conditionChange', value, value.subject, value.school_year, value.day_of_week, value.deafness);
    this.condition = value;
  }

  handleDateClick(arg: DateClickEvent) {
    console.log('handleDateClick');
  }

  async eventClick(e: any) {
    const teacher = this.lessons.find((p) => {
      // console.log(p, p.shiftTable?.shift_table_id, e.event.id);
      return p.shiftTable?.shift_table_id == e.event.id; // カレンダーでIDが文字列形になるのであえて、String
    });
    if (!teacher?.teacher?.user_id) {
      await MessageDialog.systemError('ユーザーID', 'DA予約ダイアログ表示時');
      return;
    }

    const dialog: StudentLessonRequestDialog = this.$refs['dialog'] as StudentLessonRequestDialog;
    dialog.show(teacher.teacher.user_id, e.event.id, e.event.start, e.event.end);
  }

  datesRender(event: any, el: any) {
    const view: TimeGridView = event.view;
    const start = view.activeStart;
    const end = view.activeEnd;
    this.loadData(start, end);
  }

  showList() {
    routeHelper(this, 'StudentLessonListDaPage');
  }
}
